export const EMAILTEMPLATE = 'SET_EMAIL_TEMPLATES';
export const COMMUNICATIONSTATUS = 'SET_COMMUNICATION_STATUSES';
export const COUNTRY = 'SET_COUNTRIES';

